
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { AppConfig, AppConfiguration } from 'src/configuration';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AllService {
  constructor(
    @Inject(AppConfig) private readonly appConfig: AppConfiguration,
    private router: Router,
    private http: HttpClient
  ) {}

  getHe(token): Observable<any> {
    return this.http.get<any>(this.appConfig.UniSystemAPI + 'He/Danh_sach_he', {
         headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
      }).pipe(map((z) => {return z;}));
  }
  getKhoa(token): Observable<any> {
    return this.http.get<any>(this.appConfig.UniSystemAPI + 'Khoa/Danh_sach_khoa', {
         headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
      }).pipe(map((z) => {return z;}));
  }
  getKhoaHoc(token): Observable<any> {
    return this.http.get<any>(this.appConfig.UniSystemAPI + 'Core/KhoaHoc_Load_List', {
         headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
      }).pipe(map((z) => {return z;}));
  }
  getChuyenNganh(token): Observable<any> {
    return this.http.get<any>(this.appConfig.UniSystemAPI + 'ChuyenNganh/Danh_sach_chuyen_nganh').pipe(map((z) => {return z;}));
  }
  getNganh(): Observable<any> {
    return this.http.get<any>(this.appConfig.UniSystemAPI + 'Nganh/Danh_sach_nganh').pipe(map((z) => {return z;}));
  }
  getLop(token): Observable<any> {
    return this.http.get<any>(this.appConfig.UniSystemAPI + 'Lop/Danh_sach_lop_dang_hoc', {
         headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
      }).pipe(map((z) => {return z;}));
  }
  getNhomCongViec(token: any): Observable<any> {
    return this.http.get<any>(this.appConfig.UniTeacher + 'WorkGroup/ListAll', {
      headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
    }).pipe(map((z) => {return z;}));
  }
  getCongViec(token: any): Observable<any> {
    return this.http.get<any>(this.appConfig.UniTeacher + 'Work/ListAll', {
      headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
    }).pipe(map((z) => {return z;}));
  }
  getBoMon(token: any): Observable<any> {
    return this.http.get<any>(this.appConfig.UniSystemAPI + 'BoMon/Danh_sach_bo_mon', {
         headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
      }).pipe(map((z) => {return z;}));
  }
  getLoaiLop(token: any): Observable<any> {
    return this.http.get<any>(this.appConfig.UniTeacher + 'ClassType/ListAll', {
      headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)
    }).pipe(map((z) => {return z;}));
  }
}
